/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type UserRole = 'researcher' | 'patient' | 'doctor' | 'med_staff' | 'organization';

export const UserRole = {
    Researcher: 'researcher' as UserRole,
    Patient: 'patient' as UserRole,
    Doctor: 'doctor' as UserRole,
    MedStaff: 'med_staff' as UserRole,
    Organization: 'organization' as UserRole
};